<p-confirmDialog key="errorcheck" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainGrid2Col">
	<label class="NoMargin">Student ID:</label>
	<label class="NoMargin">{{ StudentID }}</label>

	<label class="NoMargin">Student Name:</label>
	<label class="NoMargin">{{ StudentName }}</label>

	<label class="NoMargin">Date:</label>
	<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="EntryDate" name="EntryDate" [disabled]="IsLoading() == true"></p-calendar>

	<label class="NoMargin">Time:</label>
	<p-calendar
		showTime="true"
		hourFormat="12"
		timeOnly="true"
		showIcon="true"
		showButtonBar="false"
		[(ngModel)]="EntryTime"
		name="EntryTime"
		[disabled]="IsLoading() == true"
	></p-calendar>

	<label class="NoMargin">Status:</label>
	<select class="form-control" [(ngModel)]="StatusID" (ngModelChange)="onStatusChange($event)" [disabled]="IsLoading() == true">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstAttendanceStatus" [ngValue]="o.AttendanceStatusID">
			{{ o.AttendanceStatusDesc }}
		</option>
	</select>

	<label class="NoMargin">Excuse:</label>
	<select
		[disabled]="HasExcuse() == false"
		class="form-control"
		[(ngModel)]="Excuse"
		[style.color]="Excuse?.IsCountAsPresent == true ? 'Green' : 'Red'"
		[disabled]="IsLoading() == true"
	>
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstExcuse" [ngValue]="o" [style.color]="o?.IsCountAsPresent == true ? 'Green' : 'Red'">
			{{ o.ExcuseDesc }}
		</option>
	</select>

	<div></div>
	<label><span style="color: red">Red</span> = Unexcused absent, <span style="color: green">Green</span> = Excused absent</label>

	<label class="NoMargin">Comments:</label>
	<textarea class="TextArea" rows="5" [(ngModel)]="Comments" [disabled]="IsLoading() == true"></textarea>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAddAttendance()">Add</button>
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
